<template>
  <div class="flex flex-col lg:flex-row">
    <!-- Main Content -->
    <div class="flex-1 lg:mr-6 mb-6 lg:mb-0">
      <vs-card class="h-full">
        <div style="padding: 1.5rem 1.5rem 0" class="flex flex-wrap w-full justify-between">
          <h4>Patient Details</h4>
          <button class="underline text-base border-none bg-white shadow-none cursor-pointer mt-1" color="primary"
                  type="flat" @click="editPatientDetailsDrawer()"> Edit </button>
        </div>

        <div class="flex flex-wrap">
          <div class="flex w-full lg:w-1/3">
            <div class="w-full m-5">
              <label for="firstName">First Name</label>
              <p id="firstName">{{ firstName }}</p>
            </div>
          </div>

          <div class="flex w-full lg:w-1/3">
            <div class="w-full m-5">
              <label for="lastName">Last Name</label>
              <p id="lastName">{{ lastName }}</p>
            </div>
          </div>

          <div class="flex w-full lg:w-1/3">
            <div class="w-full m-5">
              <label for="dateOfBirth">DOB</label>
              <p id="dateOfBirth">
                {{ moment(dateOfBirth).format("DD/MM/YYYY") }}
              </p>
            </div>
          </div>

          <div class="flex w-full lg:w-1/3">
            <div class="w-full m-5">
              <label for="email">Email</label>
              <p id="email">{{ email }}</p>
            </div>
          </div>

          <div class="flex w-full lg:w-1/3">
            <div class="w-full m-5">
              <label for="gender">Gender</label>
              <p id="gender">{{ gender | capitalize }}</p>
            </div>
          </div>

          <div class="flex w-full lg:w-1/3">
            <div class="w-full m-5">
              <label for="address">Address</label>
              <p id="address">{{ address }}</p>
            </div>
          </div>

          <div class="flex w-full lg:w-1/3">
            <div class="w-full m-5">
              <label for="contactNumber">Contact Number</label>
              <p id="contactNumber">{{ contactNumber }}</p>
            </div>
          </div>

          <div v-if="displayHealthTreatment" class="flex w-full lg:w-1/3"> 
            <div class="w-full m-5">
              <label for="medicare">Medicare</label>
              <div class="mt-2">
                <vs-button 
                  @click="showMedicareModal = true"
                  type="filled"
                  size="medium"
                  class="custom-medicare-btn"
                >
                  View Details
                </vs-button>
              </div>
            </div>
          </div>
        </div>
      </vs-card>

      <MedicalDetail
        v-if="check_has_permission('viewPatientMedicalDetail')"
        :allergies="allergies"
        :regularMedications="regularMedications"
        :previousMedicalDiagnoses="previousMedicalDiagnoses"
      />
    </div>
    
    <PatientFilesSection 
      :patientId="$route.params.patientId"
      :showFilesFeature="showFilesFeature"
      @viewPatientFiles="$emit('viewPatientFiles', $route.params.patientId)"
    />
    
    <SideDrawerEditPatient
      :patient=patientData
      @refetchPatientDetail=rerfreshData
      ref="sideDrawerEditPatient"
    />

    <!-- Medicare Details Modal -->
    <MedicareDetailsDialog
      :is-visible="showMedicareModal"
      :medicare-data="patientData"
      @update:is-visible="showMedicareModal = $event"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import MedicalDetail from './MedicalDetail';
import PatientFilesSection from './PatientFilesSection.vue';
import SideDrawerEditPatient from '@/views/general-component/treatment-history/SideDrawerEditPatient.vue';
import MedicareDetailsDialog from './MedicareDetailsDialog.vue';
import moment from 'moment';
import { hasHealthTreatment } from '@/utils/healthTreatment';
import FEATURE_FLAGS from '@/constants/featureFlags';

export default {
  name: 'PatientDetail',

  components: {
    MedicalDetail,
    PatientFilesSection,
    SideDrawerEditPatient,
    MedicareDetailsDialog,
  },
  props: {
    backRoute: {
      type: String,
      default: 'PatientManagement',
    },
  },
  data() {
    return {
      email: '',
      dateOfBirth: '',
      profileImage: '',
      allergies: [],
      regularMedications: [],
      previousMedicalDiagnoses: [],
      status: '',
      address: '',
      lastName: '',
      contactNumber: '',
      firstName: '',
      gender: '',
      showFilesFeature: false,
      showMedicareModal: false,
      patientTreatments: [],
      patientData:{
        email: '',
        dateOfBirth: '',
        profileImage: '',
        allergies: [],
        regularMedications: [],
        previousMedicalDiagnoses: [],
        status: '',
        address: '',
        lastName: '',
        contactNumber: '',
        firstName: '',
        gender: '',
        medicareInfo:{
          medicareCardName: '',
          medicareNumber: '',
          medicareRefNumber: '',
          medicareExpiryDate: '',
        },
        ihiNumber: '',
      },
    };
  },
  computed: {
    displayHealthTreatment() {
      return hasHealthTreatment(this.patientData.medicareInfo, this.patientData.ihiNumber);
    },
  },
  methods: {
    ...mapActions('patient', ['patientDetail2', 'patientTreatmentList2']),
    moment(date) {
      return moment(date);
    },
    editPatientDetailsDrawer() {
      this.$refs.sideDrawerEditPatient.openSideDrawer();
    },
    rerfreshData() {
      this.$vs.loading();
      this.getPatientDetail(this.$route.params.patientId);
      setTimeout(() => {
        this.$vs.loading.close();
      }, 500);
    },
    openFile(file) {
      window.open(file.url, '_blank');
    },
    
    async getPatientDetail(patientId) {
      await this.patientDetail2(patientId)
        .then((res) => {
          if (res.data.data.permissions) {
            this.$store.commit(
              'UPDATE_USER_PERMISSION',
              res.data.data.permissions
            );
          }
          const patientData = res.data.data;
          this.patientData = patientData;
          this.dateOfBirth = patientData.dateOfBirth;
          this.profileImage = patientData.profileImage;
          this.allergies = patientData.allergies;
          this.regularMedications = patientData.regularMedications;
          this.previousMedicalDiagnoses = patientData.previousMedicalDiagnoses;
          this.status = patientData.status;
          this.address = patientData.address;
          this.lastName = patientData.lastName;
          this.contactNumber = patientData.contactNumber;
          this.firstName = patientData.firstName;
          this.gender = patientData.gender;
          this.email = patientData.email;
          this.patientData.medicareInfo = {
            medicareCardName: patientData.medicareCardName,
            medicareNumber: patientData.medicareNumber,
            medicareRefNumber: patientData.medicareRefNumber,
            medicareExpiryDate: patientData.medicareExpiryDate,
          },
          this.patientData.ihiNumber = patientData.ihiNumber;
        })
        .catch((err) => console.log('*******************', err));
    },
    
    async getPatientTreatments(patientId) {
      try {
        const params = {
          patientId: patientId,
          limit: 100,
        };
        const response = await this.patientTreatmentList2(params);
        this.patientTreatments = response.data.data.docs || [];
      } catch (err) {
        console.log('Error fetching patient treatments:', err);
        this.patientTreatments = [];
      }
    },
  },
  async created() {
    let patientId = this.$route.params.patientId;
    await this.getPatientDetail(patientId);
    await this.getPatientTreatments(patientId);
    
    this.showFilesFeature = await this.$ld.getFlag(FEATURE_FLAGS.WEB_PATIENT_DOCUMENTS, false);
    
    this.$ld.subscribe(FEATURE_FLAGS.WEB_PATIENT_DOCUMENTS, (changes) => {
      this.showFilesFeature = changes.current;
    });
  },
  destroyed() {
    this.$ld.unsub(FEATURE_FLAGS.WEB_PATIENT_DOCUMENTS);
  },
};
</script>

<style>
p {
  font-size: 15px;
  font-weight: 500;
}
.sidebarx .vs-sidebar-primary {
  max-width: none;
}

@media (min-width: 768px) {
  .sidebarx .vs-sidebar-primary {
    max-width: 350px;
  }
}
.vs-sidebar--background {
  z-index: 52000 !important;
}

.vs-sidebar.vs-sidebar-position-right {
  z-index: 53000;
}

/* Medicare Button Styles */
.custom-medicare-btn {
  background-color: #D3F2EE !important;
  color: #0F9E8B !important;
  border-radius: 20px !important;
  font-size: 12px !important;
  padding: 7px 26px !important;
}

.custom-medicare-btn:hover {
  background-color: #B8E8E0 !important;
  transform: translateY(-1px);
}
</style>
